<template>
  <div class="tablet">
    <table>
      <thead>
        <tr>
          <th class="tablet__header">Пользователь</th>
          <th class="tablet__header">Дата / Время</th>
        </tr>
      </thead>
    </table>
    <div class="tablet__body tablet-body">
      <table>
        <tbody>
          <tr v-if="dataTable?.length === 0 || dataTable === null">
            Нет истории изменений
          </tr>
          <tr
            v-for="(item, idx) in dataTable"
            :key="idx"
            :class="{
              'selected': activeHistoryId === item.EntityObjectId,
              'selected_default': selectedDefaultId === item.EntityObjectId,
            }"
            @click="selectItem(item.EntityObjectId)"
          >
            <td class="tablet-body__text">
              {{ item.User }}
              <i
                class="gg-check-o tablet-body__icon"
                v-if="originNewsId === item.EntityObjectId"
              />
            </td>
            <td class="tablet-body__text">{{ formaterDate(item.Date) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    <div class="tablet__buttons">
      <base-btn-new
        name='Выбрать'
        @click-btn="$emit('selectVersion', activeHistoryId)"
      >
        <HistoryVersionIconNew/>
      </base-btn-new>
      <!-- <base-btn
        text='Отмена'
        @click-btn="$emit('closeModal', 'Story', false)"
      /> -->
    </div>
</template>

<script>
import { ref } from 'vue'
// import { useStore } from 'vuex'
// import router from '@/router'

import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import HistoryVersionIconNew from '@/components/icons/HistoryVersionIconNew.vue'

export default {
  name: 'StoryChangeModal',
  components: {
    BaseBtnNew,
    HistoryVersionIconNew
  },
  props: {
    dataTable: {
      type: Object,
      default: () => {}
    },
    typeVersion: {
      type: String,
      default: 'fromEditor'
    },
    selectedDefaultId: {
      type: Number,
      default: 0
    },
    originNewsId: {
      type: Number,
      default: 0
    }
  },
  setup (_, { emit }) {
    // const store = useStore()

    // выбранная строчка в таблице
    const activeHistoryId = ref(0)

    // выбирает строчку в таблице
    const selectItem = (id) => {
      activeHistoryId.value = id
    }

    // // данные с таблички
    // const dataTable = computed(() => {
    //   return store.getters.getChangeHistoryData
    // })

    // форматирует дату
    const formaterDate = (val) => {
      if (val !== null && val !== '') {
        const date = new Date(val)
        return date.toLocaleString('ru')
      } else {
        return ''
      }
    }

    // id новости из которой вызвано
    // const NewsFormId = computed(() => {
    //   return store.getters.getFormData.Id
    // })

    // в родитеьский компонент перенести
    // const sentSelectedItem = (type) => {
    //   if (type === 'firstCol') {
    //     // изменять первую колонку NewsVersionView
    //     store.dispatch('setFirstColData', activeHistoryId.value)
    //   } else if (type === 'secondCol') {
    //     // изменять вторую колонку NewsVersionView
    //     store.dispatch('setSecondColData', activeHistoryId.value)
    //   } else if (type === 'fromEditor') {
    //     console.log('fromEditor: ', activeHistoryId.value)
    //     // если из NewsEditorView вызвана модалка
    //     store.dispatch('setFirstColData', activeHistoryId.value)
    //     // store.dispatch('setSecondColData', NewsFormId.value)
    //     router.push(`/news/version/${NewsFormId.value}`)
    //   }

    //   emit('closeModal', 'all', false)
    // }

    return {
      selectItem,
      activeHistoryId,
      // dataTable,
      formaterDate
      // sentSelectedItem
    }
  }
}
</script>

<style lang="scss" scoped>
.tablet {
  width: 720px;
  height: 428px;
  color: #000000;
  font-size: 18px;

  &__header {
    padding: 10px 12px;
    font-weight: 400;
    border: none;
    color: #FFFFFF;
    background-color: #E6E6E6;;
    font-size: 16px;
    color: #787878;
    &:first-child {
      border-radius: 6px 0px 0px 0px;
    }
    &:last-child {
      border-radius: 0px 6px 0px 0px;
    }
  }

  &__body, .tablet-body {
    max-height: 297px;
    overflow-x: auto;
    margin-top: 0px;
    margin-bottom: 20px;
    border-bottom: 1px solid #787878;
    border-bottom: none;

    &__text {
      padding: 10px 18px;
      font-size: 16px;
      border: 1px solid #787878;
      border-top: none;
      color: #000000;
      cursor: pointer;
    }

    &__icon {
      display: inline-block;
    }
  }

  &__buttons {
    position: absolute;
    right: 0px;
    left: 0px;
    bottom: 0px;
    padding: 24px;
    border-top: 2px solid #D6D6D6;
    background-color: #F5F5F5;
    display: flex;
    justify-content: flex-end;
    gap: 30px;
    width: 100%;
    :deep(.base-button) {
      width: 200px;
    }
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
::-webkit-scrollbar-thumb {
  background-color: #00ABEC;
  height: 100px;
}

table {
  width:100%;
  table-layout: fixed;
  border: none;
  border-collapse: collapse;
}

:deep(.modal) {
  width: 599px;
  min-height: 440px;
}
.selected {
  background:#0080B1;
  color: #FFFFFF;
  .gg-check-o {
    color: #FFFFFF;
  }

  &_default {

    .tablet-body__text {
      color: #0080B1;
    }
  }

  .tablet-body__text {
    color: #FFFFFF;
    border-color: #0080B1;
  }
}

// иконка
.gg-check-o {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs,1));
  width: 22px;
  height: 22px;
  border: 2px solid;
  border-radius: 100px;
  color: #0080B1;
}
.gg-check-o::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  left: 3px;
  top: -1px;
  width: 6px;
  height: 10px;
  border-color: currentColor;
  border-width: 0 2px 2px 0;
  border-style: solid;
  transform-origin: bottom left;
  transform: rotate(45deg)
}

</style>
